import { SearchFilterPipe } from '../customer/feature/shared/pipes/searchfilter.pipe';
import { CheckedUncheckedPipe } from '../customer/feature/shared/pipes/checkedUnchecked.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SortingListPipe } from '../customer/feature/newrequest/proposedsolution/pipes/sorting-list.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule
    ],
    declarations: [
        SearchFilterPipe,
        CheckedUncheckedPipe,
        SortingListPipe
    ],
    exports: [
        SearchFilterPipe,
        CheckedUncheckedPipe,
        SortingListPipe,
        CommonModule,
        FormsModule,
        TranslateModule
    ]
})
export class SharedModule { }
